import React, { useMemo } from 'react'
import { type GridColumns } from '@retailer-platform/shared-components'
import { colors } from '@retailer-platform/shared-components'
import { SVGIcon } from 'ic-snacks'
import { useDomainMessages } from 'domains/collections/utils/domain/intl'
import { type CollectionDatum } from 'domains/collections/types/collections.types'
import { CollectionsListContentCell } from 'domains/collections/components/collections-list/components/content-cell/CollectionsListContentCell'
import { CollectionsListDatesCell } from 'domains/collections/components/collections-list/components/dates-cell/CollectionsListDatesCell'

interface Props {
  onDelete?: (collectionId: string) => void
}

export const useChildCollectionsListColumns = ({ onDelete }: Props) => {
  const columnHeaders = useDomainMessages({
    name: 'collectionsDomain.list.columns.name.header',
    content: 'collectionsDomain.list.columns.content.header',
    activeDates: 'collectionsDomain.list.columns.activeDates.header',
  })

  const columns = useMemo(() => {
    const columns: GridColumns<CollectionDatum> = [
      {
        id: 'name',
        Header: columnHeaders.name,
        Cell: ({ row }) => row.original.name,
      },
      {
        id: 'content',
        Header: columnHeaders.content,
        Cell: ({ row }) => <CollectionsListContentCell collection={row.original} />,
      },
      {
        id: 'activeDates',
        Header: columnHeaders.activeDates,
        Cell: ({ row }) => <CollectionsListDatesCell collection={row.original} />,
      },
    ]

    if (onDelete !== undefined) {
      columns.push({
        id: 'actions',
        Cell: ({ row }) => (
          <div onClick={() => onDelete(row.original.id)}>
            <SVGIcon
              css={{
                cursor: 'pointer',
              }}
              color={colors.DETRIMENTAL.REGULAR}
              name="deleteFilled"
            />
          </div>
        ),
        width: 30,
      })
    }

    return columns
  }, [columnHeaders, onDelete])

  return columns
}
